// Chart configuration constants
export const CHART_COLORS = {
  ACTUAL_COLLECTION: {
    backgroundColor: "#FE8D01",
    borderColor: "#ff6b35",
  },
  TARGET: {
    backgroundColor: "#111C3A",
    borderColor: "#9ca3af",
  },
} as const;

export const CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "bottom" as const,
      usePointStyle: true,
      labels: {
        usePointStyle: true,
        pointStyle: "rect",
      },
    },
    title: {
      display: false,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        callback: function (value: any) {
          return "₹" + value.toLocaleString();
        },
      },
    },
  },
} as const;

// Month names mapping
export const MONTH_NAMES = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
] as const;

// Chart dataset labels
export const CHART_LABELS = {
  ACTUAL_COLLECTION: "Actual Collection",
  TARGET: "Target",
} as const;

// UI text constants
export const UI_TEXT = {
  TITLE: "Collections Summary",
  LOADING: "Loading...",
  ERROR_PREFIX: "Error loading data:",
  NO_DATA_TITLE: "No Data Available",
  NO_DATA_DESCRIPTION: "No collection data found for the selected filters.",
  PLACEHOLDERS: {
    YEAR: "Select Year",
    SCHOOL: "Select School",
    SEARCH_YEARS: "Search years...",
    SEARCH_SCHOOLS: "Search schools...",
    NO_YEARS: "No years found",
    NO_SCHOOLS: "No schools found",
  },
} as const;

// Types
export interface School {
  value: string;
  label: string;
}

// Mock data constants
export const MOCK_SCHOOLS: School[] = [
  { value: '', label: 'All Schools' },
  { value: '1', label: 'Model School 1' },
  { value: '2', label: 'Model School 2' },
  { value: '3', label: 'Model School 3' },
];

// Year range configuration
export const YEAR_RANGE = {
  YEARS_BEFORE_CURRENT: 5,
  YEARS_AFTER_CURRENT: 5,
} as const;
